module.exports = __webpack_public_path__ + "img/imagefilm-screenshot.9e9e4bbe.jpg";